export default () => {
    const tabbedContent = document
        .querySelector('.tabbed-content')

    // If there's no tabbedContent, return
    if (!tabbedContent)
        return

    const tabLinks = tabbedContent
        .querySelectorAll('button[data-bs-toggle="tab"]')

    const select = tabbedContent
        .querySelector('.tabbed-content-select select')

    const selectOptions = Array.from(select
        .querySelectorAll('option'))

    const selectActive = tabbedContent
        .querySelector('.tabbed-content-select-active')

    const openTab = (_, hash) => {
        const tabId = hash
            || select.value

        if (tabId) {
            const tabBtn = tabbedContent
                .querySelector(`[data-bs-target="${tabId}"]`)

            if (tabBtn) {
                tabBtn.click()

                updSelected(tabId)
            }
        }
    }

    const updSelected = (id) => {
        const tabBtn = tabbedContent
            .querySelector(`[data-bs-target="${id}"]`)

        const ariaLabel = tabBtn
            .getAttribute('aria-label')

        selectOptions.forEach(item => {
            if (item.value === id)
                item.setAttribute('selected', 'selected')
            else
                item.removeAttribute('selected')
        })

        if (selectActive)
            selectActive.textContent = ariaLabel
    }

    const start = () => {
        const hash = window.location.hash

        if (hash)
            openTab(undefined, hash)

        // check tab changes
        tabLinks.forEach((tabLink) => {
            tabLink.addEventListener('shown.bs.tab', (ev) => {
                const targetId = ev.target
                    ?.getAttribute('data-bs-target')

                const targetEl = document
                    .querySelector(targetId)

                if (targetEl) {
                    targetEl.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    })

                    updSelected(targetId)
                }
            })
        })
    }

    if (select)
        select.addEventListener('change',
            openTab)

    if (tabLinks)
        start()
}
